
import { Component, Inject, Input, OnChanges, SimpleChanges
       } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { SVG, Image } from '@svgdotjs/svg.js';
import { StageService
       } from 'collage-designer/stage/stage.service';
import { Utils } from 'core/utils';
import { ImageQualityRatingService } from './image-quality-rating.service';

@Component({
    selector: 'image-quality-rating',
    templateUrl: './image-quality-rating.component.html',
    styleUrls: ['./image-quality-rating.component.scss'],
    standalone: false
})

export class ImageQualityRatingComponent implements OnChanges
{
  @Input() public domImageId: string;
  @Input() public calculationMode: string = 'dynamic';
  @Input() public staticQualityRatingValue: number;

  public imageQualityRating: number = 0;

  constructor(
      private mir: MatIconRegistry,
      private sanitizer: DomSanitizer,
      @Inject(ImageQualityRatingService) private imageQualityRatingService:
          ImageQualityRatingService,
      @Inject(StageService) private stageService: StageService)
  {
    this.mir.addSvgIcon(
        'stars',
        this.sanitizer.bypassSecurityTrustResourceUrl(Utils.url(
            './assets/img/icons/stars.svg')));
  }

  public ngOnChanges(changes: SimpleChanges): void
  {
    if (this.calculationMode === 'dynamic') {
      const stage = this.stageService.getCurrentStageReference();
      const image = stage.find(`#${this.domImageId}`).at(0) as Image;
      this.imageQualityRating =
        this.imageQualityRatingService.readQualityRating(image);
    }
    else {
      this.imageQualityRating = this.staticQualityRatingValue === undefined ?
          1 : this.staticQualityRatingValue;
    }
  }
}
